
import BannerContainer from '~/components/child/banner/BannerContainer.vue';
import TagContainer from '~/components/child/tag/TagContainer.vue';
import RecipeContainer from '~/components/child/recipe/RecipeContainer.vue';
import BrowseContainer from '~/components/child/browse/BrowseContainer.vue';
import ArticleChannelContainer from '~/components/child/article/ArticleChannelContainer.vue';
import BloggerRankingChannel from '~/components/child/blogger/BloggerRankingChannel.vue';
import ArticleHotContainer from '~/components/child/article/ArticleHotContainer.vue';
export default {
    name: "travel",
    components: { BannerContainer, TagContainer, RecipeContainer, BrowseContainer, ArticleChannelContainer, BloggerRankingChannel, ArticleHotContainer },
    head() {
        return {
            title: '美食-PIXNET痞客邦',
            meta: [
                { hid: 'description', name: 'description', content: '痞客邦有網友在線分享的全台食記、食譜、新餐廳、人氣美食、吃到飽、排隊小吃、網美甜點、推薦伴手禮、台灣小吃……各種美味好料，由達人為您帶路，通通看得到。' },
                { hid: 'og:description', name: 'og:description', property: 'og:description', content: '痞客邦有網友在線分享的全台食記、食譜、新餐廳、人氣美食、吃到飽、排隊小吃、網美甜點、推薦伴手禮、台灣小吃……各種美味好料，由達人為您帶路，通通看得到。' },
                { hid: 'twitter:description', name: 'twitter:description', property: 'twitter:description', content: '痞客邦有網友在線分享的全台食記、食譜、新餐廳、人氣美食、吃到飽、排隊小吃、網美甜點、推薦伴手禮、台灣小吃……各種美味好料，由達人為您帶路，通通看得到。' },
                { hid: 'keywords', name: 'keywords', content: '美食，吃到飽，人氣餐廳，網美餐廳，景觀餐廳，親子餐廳，寵物友善餐廳，小吃，手搖，火鍋，燒烤，甜點，食譜，料理' },
                { hid: 'og:title', name: 'og:title', property: 'og:title', content: "美食-PIXNET痞客邦"},
                { property: 'og:image', property: 'og:image', content: "https://www.pixnet.net/img/public/og/img_food_og.png"},
                { property: 'og:image:secure_url', property: 'og:image:secure_url', content: "https://www.pixnet.net/img/public/og/img_food_og.png"},
                { property: 'twitter:image', property: 'twitter:image', content: "https://www.pixnet.net/img/public/og/img_food_og.png"},
                { property: 'image', name: 'image', itemprop: 'image', content: "https://www.pixnet.net/img/public/og/img_food_og.png"},
            ],
            link: [
                { rel: 'canonical', href: 'https://www.pixnet.net/channel/food', key: "canonical"}
            ]
        }
    },
    jsonld() {
        return {
            "@context": " https://schema.org/",
            "@graph": [
                {
                    "@context":"https://schema.org",
                    "@type":"Organization",
                    "url":"https://www.pixnet.net",
                    "logo":"https://www.pixnet.net/img/public/og/img_food_og.png",
                    "name":"痞客邦",
                    "@id":"https://www.pixnet.net/#organization",
                    "description":"痞客邦有網友在線分享的全台食記、食譜、新餐廳、人氣美食、吃到飽、排隊小吃、網美甜點、推薦伴手禮、台灣小吃……各種美味好料，由達人為您帶路，通通看得到。",
                    "address":"",
                    "brand":{
                        "@type":"Brand",
                        "logo":"https://www.pixnet.net/img/public/og/img_food_og.png"
                    },
                    "sameAs":"https://www.facebook.com/pixnet.net"
                },
                {
                    "@context":"https://schema.org/",
                    "@type":"BreadcrumbList",
                    "itemListElement":[
                        {
                            "@type": "ListItem",
                            "position": 1,
                            "name": "美食-PIXNET痞客邦",
                            "item": "https://www.pixnet.net",
                            "description": "痞客邦有網友在線分享的全台食記、食譜、新餐廳、人氣美食、吃到飽、排隊小吃、網美甜點、推薦伴手禮、台灣小吃……各種美味好料，由達人為您帶路，通通看得到。",
                            "keywords": "美食，吃到飽，人氣餐廳，網美餐廳，景觀餐廳，親子餐廳，寵物友善餐廳，小吃，手搖，火鍋，燒烤，甜點，食譜，料理"
                        }
                    ]
                }
            ]
        }
    },
    data() {
        return {
            channel_page_id: 1,
            showAnimation: false,
        }
    },
    computed: {
        is_login() {
            return this.$store.state.login.login_status;
        },
        tab_id() {
            return this.$store.state.channel_tab.tab_id;
        },
        tab_left() {
            return this.$store.state.channel_tab.tab_highlight_style.left;
        },
        tab_width() {
            return this.$store.state.channel_tab.tab_highlight_style.width;
        },
        window_width() {
            return this.$store.state.channel_tab.window_width;
        },
        pa_page_name() {
            return '美食';
        },
        tag_search_text() {
            return '美食';
        },
        day_hot_article() {
            return this.$store.state.article.day_hot_article;
        },
        day_hot_article_full() {
            return this.$store.state.article.day_hot_article_full;
        }
    },
    methods: {
        paFunction() {
            window._piq.push(['trackEvent', 'rs2022::十大頻道::' + this.pa_page_name, 'imps::頁面::page::user_action', '', '']);
        },
        paScrollFunction(){
            addEventListener("scroll", () => {
                window._piq.push(['trackEvent', 'rs2022::十大頻道::' + this.pa_page_name, 'scroll::頁面::page::user_action', '', '']);
            }, { once: true });
        },
        gtag(){
            window.dataLayer.push(arguments);
        },
        activeGaPage() {
            this.gtag('config', 'G-RPGK0ML6QM', {
                'channel_category': '美食'
            });
            this.gtag('config', 'G-45SMZ66RLZ', {
                'channel_category': '美食'
            });
            this.gtag('event', 'page_view', {
                page_title: '美食-PIXNET痞客邦',
            });
        },
        activeMcPage() {
            (function(c,l,a,r,i,t,y){
                c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
                t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
                y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
            })(window, document, "clarity", "script", "kbvat69or6");
        },
    },
    async fetch(){
        const item = { sort: 'hot', type: 'group', pre_page: 10, id: this.channel_page_id, ver: 2 }
        await this.$store.dispatch("article/getDayHotArticle", item);
    },
    mounted() {
        window.dataLayer = window.dataLayer || [];
        this.activeGaPage();
        this.activeMcPage();
        this.paFunction();
        this.paScrollFunction();
    }
}
